import { Deferred as e } from "../internal/deferred.js";
import "../internal/fnv1a64.js"; /**
                                 * @license
                                 * Copyright 2021 Google LLC
                                 * SPDX-License-Identifier: BSD-3-Clause
                                 */
var r = new e();
r.resolve();